import { NgModule } from '@angular/core'
import { RouterModule, Routes } from '@angular/router'

import { environment } from '@flowx/designer/environment'

import { AppGuardedRoutes } from './app-guarded-routes'
import { AuthGuardWithForcedLogin } from './modules/auth/auth-guard-with-forced-login.service'

export const routes: Routes = [
  // Logs in first, then lands.
  {
    path: '',
    redirectTo: 'guard',
    pathMatch: 'full',
  },
  {
    path: 'start',
    loadComponent: () =>
      import('./modules/auth/start-layout/start-layout.component').then(
        ({ StartLayoutComponent }) => StartLayoutComponent
      ),
    loadChildren: () => import('./modules/auth/auth-routes').then(({ AuthRoutes }) => AuthRoutes),
  },

  {
    path: 'login-failure',
    loadComponent: () =>
      import('@flowx/designer/shared/components/login-failure/login-failure.component').then(
        ({ LoginFailureComponent }) => LoginFailureComponent
      ),
  },
  {
    path: 'guard',
    canActivate: [AuthGuardWithForcedLogin],
    loadComponent: () =>
      import('./modules/auth/app-guard/app-guard.component').then(
        ({ AppGuardComponent }) => AppGuardComponent
      ),
    children: AppGuardedRoutes,
  },
  // Logs in first, like `/guard`, since the global header shows here too.
  {
    path: '403',
    canActivate: [AuthGuardWithForcedLogin],
    loadComponent: () =>
      import('@flowx/designer/modules/core/authorization-error/authorization-error.component').then(
        ({ AuthorizationErrorComponent }) => AuthorizationErrorComponent
      ),
  },
  { path: '**', redirectTo: '403' },
]

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      enableTracing: environment.debug.ngRouter,
      bindToComponentInputs: true,
      paramsInheritanceStrategy: 'always',
      anchorScrolling: 'enabled',
      scrollPositionRestoration: 'enabled',
    }),
  ],
  exports: [RouterModule],
  providers: [],
})
export class AppRoutingModule {}
